import gql from 'graphql-tag';

export const schema = gql`
  mutation CreatePropertyListingPublicationUploadUrl(
    $publicationId: String!
    $fileName: String!
  ) {
    createPropertyListingPublicationUploadUrl(
      publicationId: $publicationId
      fileName: $fileName
    ) {
      __typename

      ... on CreatePropertyListingPublicationUploadMediaUrlFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }

      ... on CreatePropertyListingPublicationUploadMediaUrlSuccess {
        attachmentId
        uploadPath
        uploadUrl
      }
    }
  }
`;
